export default {
  disabled: {
    title: "La facturation n'est pas gérée sur la plateforme",
    description:
      'Les abonnements et factures ne sont pas disponibles car la facturation entre vous et vos restaurants est réglée hors plateforme. Les versements, relevés et rapports restent disponibles.',
  },
};
